import { api } from './client';
import type {
  IngredientListResponse,
  IngredientDetailResponse,
  IngredientUpdateResponse,
  IngredientImpactResponse,
} from './types';

export function getIngredients(params: {
  page: number;
  limit?: number;
  search?: string;
  autoLearned?: boolean;
}) {
  const qs = new URLSearchParams({ page: String(params.page) });
  if (params.limit) qs.set('limit', String(params.limit));
  if (params.search) qs.set('search', params.search);
  if (params.autoLearned) qs.set('auto_learned', 'true');
  return api.get<IngredientListResponse>(`/api/admin/ingredients?${qs}`);
}

export function getIngredient(id: number) {
  return api.get<IngredientDetailResponse>(`/api/admin/ingredients/${id}`);
}

export function getIngredientImpact(id: number) {
  return api.get<IngredientImpactResponse>(`/api/admin/ingredients/${id}/impact`);
}

export function updateIngredient(id: number, fields: Record<string, unknown>) {
  return api.put<IngredientUpdateResponse>(`/api/admin/ingredients/${id}`, fields);
}
